module.exports = __webpack_public_path__ + "static/media/movie-logo.687db8d3.svg";